import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import './Switch.scss';

function Switch(props) {
  const { className, disabled, children, checked, inputProps = {}, name, variant } = props;
  const mods = {
    isChecked: checked,
    isDisabled: disabled,
  };
  const labelClassNames = classNames(className, withMods('switch', mods));

  return (
    <label htmlFor={name} className={labelClassNames}>
      {children && <span className={withMods('switch__label', mods)}>{children(checked)}</span>}
      <input
        {...inputProps}
        type="checkbox"
        id={name}
        checked={!!checked}
        disabled={disabled}
        className="switch__input"
      />
      <div className={classNames(withMods('switch__toggle', mods), variant && `switch__toggle--${variant}`)} />
    </label>
  );
}

Switch.defaultProps = {
  className: '',
  disabled: false,
};

Switch.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  inputProps: PropTypes.shape({}),
  variant: PropTypes.oneOf(['brand']),
};

export default Switch;
